// @flow
import React from 'react'
import './styles.scss'

export class SvgBlinker extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isOpen: true,
      person: 0,
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800
    }
  }

  randomBlink() {
    const intervalTime = this.getRandomInt(3000, 10000)
    const blinkTime = this.getRandomInt(75, 300)
    const person = this.setState({ person: this.getRandomInt(0, 1) })
    setTimeout(
      function() {
        // console.log('> BLINK < ')
        this.setState({ isOpen: false })
        setTimeout(
          function() {
            this.setState({ isOpen: true })
          }.bind(this),
          blinkTime
        )
        this.randomBlink()
      }.bind(this),
      intervalTime
    )
  }

  getRandomInt(min, max) {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  componentDidMount() {
    this.randomBlink()
  }

  render() {
    return (
      <div
        className={
          this.props.twoPerson
            ? this.state.isOpen
              ? this.state.person
                ? 'svg-wrapper open-two'
                : 'svg-wrapper open'
              : this.state.person
              ? 'svg-wrapper blink-two'
              : 'svg-wrapper blink'
            : this.state.isOpen
            ? 'svg-wrapper open'
            : 'svg-wrapper blink'
        }
      >
        {this.props.illu}
      </div>
    )
  }
}
